import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";
import { OFFICE_IMAGE } from "@/lib/content";

export default function CTABanner() {
  return (
    <section
      data-testid="cta-banner"
      className="relative overflow-hidden bg-ink"
    >
      <img
        src={OFFICE_IMAGE}
        alt=""
        className="absolute inset-0 h-full w-full object-cover opacity-30"
      />
      <div className="absolute inset-0 bg-gradient-to-r from-ink via-ink/85 to-ink/40" />
      <div className="container-narrow relative z-10 py-24 md:py-32">
        <div className="max-w-3xl">
          <span className="text-[11px] font-medium uppercase tracking-[0.32em] text-sage-200">
            Let&apos;s talk
          </span>
          <h2 className="mt-6 text-4xl font-bold leading-tight text-white md:text-5xl lg:text-6xl">
            A short conversation is the
            <span className="italic text-sage-200"> fastest way</span> to clarity.
          </h2>
          <p className="mt-6 max-w-xl text-base leading-relaxed text-white/80 md:text-lg">
            Get in touch through our online enquiry form and a member of our
            team will respond shortly.
          </p>
          <div className="mt-10 flex flex-wrap gap-4">
            <Link
              to="/contact"
              data-testid="cta-banner-enquire"
              className="btn-primary"
            >
              Make an Enquiry <ArrowRight className="h-3.5 w-3.5" />
            </Link>
          </div>
        </div>
      </div>
    </section>
  );
}
